/* Sternkerze — Overlays oeffnen und schliessen.
   Ausloeser tragen data-sk-dialog="#id", Schliessknoepfe data-sk-dialog-zu.
   Ein Klick auf den Schleier (den <dialog> selbst) schliesst ebenfalls. */
(function () {
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-sk-dialog]');
    if (t) {
      var d = document.querySelector(t.getAttribute('data-sk-dialog'));
      if (d && typeof d.showModal === 'function') {
        d.showModal();
        document.documentElement.classList.add('sk-dialog-offen');
      }
      return;
    }
    if (e.target.closest('[data-sk-dialog-zu]')) {
      var offen = e.target.closest('dialog');
      if (offen) offen.close();
      return;
    }
    // Klick auf den Schleier: Ziel ist der dialog selbst, nicht sein Inhalt.
    if (e.target instanceof HTMLDialogElement && e.target.classList.contains('sk-dialog')) {
      e.target.close();
    }
  });

  document.addEventListener('close', function (e) {
    if (e.target instanceof HTMLDialogElement) {
      document.documentElement.classList.remove('sk-dialog-offen');
    }
  }, true);
})();
